import { render, staticRenderFns } from "./list-collection-pending-btn.vue?vue&type=template&id=2a3b8602&"
import script from "./list-collection-pending-btn.vue?vue&type=script&lang=js&"
export * from "./list-collection-pending-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports